const s = (e = {}) => {
  const {
    width: n = 0.5,
    color: i = "accent",
    radius: r = "inherit",
    offset: o = 0.5
  } = e;
  return {
    outline: "none",
    "&::after": {
      content: '""',
      position: "absolute",
      top: (t) => t.spacing(-n - o),
      right: (t) => t.spacing(-n - o),
      bottom: (t) => t.spacing(-n - o),
      left: (t) => t.spacing(-n - o),
      border: (t) => t.border(n, i),
      borderRadius: r,
      pointerEvents: "none",
      transition: "all"
    }
  };
};
export {
  s as outline
};
